module.exports = __webpack_public_path__ + "5fe47d16fabe171f689889ee7237d0af.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/plus.svg
// module id = 1316
// module chunks = 65